import { useSelector } from "react-redux";

// import { MENU_ITEMS } from "config/m";
import { MENU_ITEMS } from "config";

import { filterMenuByPermissions } from "utils/permissions/menuUtils";

// import SidebarMenu from "./SidebarMenu";
import SidebarMenuPopUp from "layouts/DashboardLayout/SidebarMenuPopUp";

export default function Sidebar(props) {
    const permissions = useSelector((state) => state.user.permissions);

    const visibleMenu = filterMenuByPermissions(MENU_ITEMS, permissions);

    return (
        <aside>
            <SidebarMenuPopUp
                items={visibleMenu}
                isCollapsed={props.isCollapsed}
            />
        </aside>
    );
}
